/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'

import { HitStateToText } from '@game/util'
import { BET_HIT_STATE } from 'adv-protocol/src/GameCommon'
import { SPECIAL_META } from '@store/oddsStore'

// css
// import styled, { Theme } from '@themes/theme'
import styled from '@themes/theme'
import { TxtLimit, Left, Right } from '@styles/base.style'
import { Num } from '@styles/match.style'
import { BettingFoldGrouped, BettingFoldData } from '@store/bettingHistoryStore'
import {
  ListItemFoldWrap,
  Hit,
  Miss,
  SpecialCase,
  // Wrap,
  OddsWrap,
  // CenterWrap,
  // ColStyle,
  // TxtColStyle,
  // StateStyle,
  TypeTxt,
  Txt,
  // TxtWrapStyle,
  PickSelect,
  PickHit,
  PickMiss,
  PickSpecialCase,
  MatchResultWrap,
  MatchResult,
  Team,
} from './index.style'

export const CenterArea = styled.div`
  position: relative;
  display: block;
  width: 45px;
  /* padding-top: 6px; */
  line-height: 1.2rem;
  text-align: center;
`

export const CenterNum = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  font-size: ${props => props.theme.font.small};
  color: ${props => props.theme.color.red};
  transform: translate(-50%, -50%);
  &.top {
    color: ${props => props.theme.color.gray};
    transform: translate(-50%, -90%);
    &.bitcoin {
      color: ${props => props.theme.color.underover};
    }
  }
  &.bottom {
    transform: translate(-50%, -10%);
  }
`

const renderOdds = (fold: BettingFoldGrouped, foldData: BettingFoldData, close1: number, close2: number) => {
  const { sportId } = fold
  const { marketType, hitState, outcomeResult, selection, outcomeRate } = foldData
  const meta = SPECIAL_META[sportId]
  const market = meta.odds[marketType]
  const left = {
    type: '1',
    rate: outcomeRate,
    name: market.oddsField['1'].name,
  }
  const right = {
    type: '2',
    rate: outcomeRate,
    name: market.oddsField['2'].name,
  }

  const MySelectionStyle = PickSelect

  let eleHitStyle
  let eleHitStyleAll
  switch (hitState) {
    case BET_HIT_STATE.SUCCESS:
      eleHitStyle = PickHit
      break
    case BET_HIT_STATE.FAIL:
      eleHitStyle = PickMiss
      break
    case BET_HIT_STATE.CANCEL:
      eleHitStyleAll = PickSpecialCase
      break
  }

  const eles = []

  // add left
  const leftHitStyle =
    (left.type === outcomeResult ? eleHitStyle : undefined) ||
    (left.type === selection ? MySelectionStyle : undefined) ||
    eleHitStyleAll

  eles.push(
    <MatchResult css={leftHitStyle}>
      <Team>
        <span className="team-name" css={TxtLimit}>{left.name}</span>
      </Team>
      <Num className="num-left betting-history" css={Right}>
        {left.rate}
      </Num>
    </MatchResult>,
  )

  // center.
  const eleCenter = []

  const ret = market.resultOutcome(close1, close2)
  for (let i = 0; i < ret.length; i += 1) {
    let sty = ''
    if (ret.length > 1) {
      sty = i === 0 ? 'top bitcoin' : 'bottom'
    }

    eleCenter.push(
      <CenterNum className={sty}>
        <span>{ret[i].l}</span>
        <span style={{ color: '#FF5733' }}>{ret[i].r}</span>
      </CenterNum>,
    )
  }
  eles.push(<CenterArea>{eleCenter}</CenterArea>)

  // add right
  const rightHitStyle =
    (right.type === outcomeResult ? eleHitStyle : undefined) ||
    (right.type === selection ? MySelectionStyle : undefined) ||
    eleHitStyleAll

  eles.push(
    <MatchResult css={rightHitStyle}>
      <Num className="num-right betting-history" css={Left}>
        {right.rate}
      </Num>
      <Team css={Right}>
        <span className="team-name" css={TxtLimit}>{right.name}</span>
      </Team>
    </MatchResult>,
  )

  return <MatchResultWrap>{eles}</MatchResultWrap>
}

interface BettingHistoryListItemFoldProps {
  fold: BettingFoldGrouped
  foldData: BettingFoldData
  close1: number
  close2: number
}

const BettingHistoryListItemFold: React.FC<BettingHistoryListItemFoldProps> = (
  props: BettingHistoryListItemFoldProps,
) => {
  const { fold, foldData, close1, close2 } = props
  const { sportId } = fold
  const { marketType, hitState, outcomeResult } = foldData
  const meta = SPECIAL_META[sportId]
  const market = meta.odds[marketType]
  const marketName = market.name
  const selectionName = market.oddsField[foldData.selection].name
  const outcomeField = market.oddsField[outcomeResult]
  const outcomeName = outcomeField ? outcomeField.name : ''

  let eleHitState
  switch (hitState) {
    case BET_HIT_STATE.SUCCESS:
      eleHitState = <Txt css={Hit}>{HitStateToText(hitState)}</Txt>
      break
    case BET_HIT_STATE.FAIL:
      eleHitState = <Txt css={Miss}>{HitStateToText(hitState)}</Txt>
      break
    case BET_HIT_STATE.CANCEL:
      eleHitState = <Txt css={SpecialCase}>{HitStateToText(hitState)}</Txt>
      break
  }

  const eleOdds = []
  eleOdds.push(<TypeTxt className="oz-type">{marketName}</TypeTxt>)

  const eleOdds2 = []
  // eleOdds2.push(<Col>{eleHitState}</Col>)
  eleOdds2.push(
    <Fragment>
      {/* <TypeTxt>{selectionName}</TypeTxt>
      <MyPickTxt>선택-</MyPickTxt> */}
      <TypeTxt className="select">선택 - {selectionName}</TypeTxt>
    </Fragment>,
  )

  if (hitState !== BET_HIT_STATE.ONGOING) {
    eleOdds2.push(
      <Fragment>
        {/* <TypeTxt>{outcomeName}</TypeTxt>
        <ResultTxt>결과-</ResultTxt> */}
        <TypeTxt>
          결과 - {outcomeName}
          <span>{eleHitState}</span>
        </TypeTxt>
      </Fragment>,
    )
  }

  const eleOdds3 = []
  const obj = renderOdds(fold, foldData, close1, close2)
  eleOdds3.push(obj)

  return (
    <ListItemFoldWrap>
      {/* <div>
          {eleOdds}
          <OddsWrap className="odds2-wrap">{eleOdds2}</OddsWrap>
          {eleOdds3}
        </div> */}
      {eleOdds}
      <OddsWrap>{eleOdds2}</OddsWrap>
      {eleOdds3}
    </ListItemFoldWrap>
  )
}

export default BettingHistoryListItemFold
